import { useTranslation } from "react-i18next";
import logoAroan from "@/assets/logo_aroan.webp";

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-foreground text-background py-10 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Logo e Info - Centralizado em mobile */}
          <div className="sm:col-span-2 lg:col-span-2 flex flex-col items-center sm:items-start text-center sm:text-left">
            <div className="mb-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-white">
                <img
                  src={logoAroan}
                  alt="Logo Aroan"
                  className="w-10 h-10 object-contain"
                  style={{ background: "white", borderRadius: "0.75rem" }}
                />
              </div>
            </div>
            <h3 className="text-2xl font-bold mb-4">AROAN</h3>
            <p className="text-background/80 text-sm leading-relaxed mb-4 max-w-xs">
              {t('footer.description')}
            </p>
            <div className="space-y-2 text-sm">
              <p className="text-background/80">
                <strong>Email:</strong> contato@aroan.com
              </p>
              <p className="text-background/80">
                <strong>Telefone:</strong> +55 (11) 3969-2042
              </p>
            </div>
          </div>

          {/* Recursos */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">{t('footer.resources')}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-background/80 hover:text-primary transition-colors">{t('footer.hubUnified')}</a></li>
              <li><a href="#" className="text-background/80 hover:text-primary transition-colors">{t('footer.noCodeAutomation')}</a></li>
              <li><a href="#" className="text-background/80 hover:text-primary transition-colors">VIA - IA</a></li>
              <li><a href="/analytics-preditivo" className="text-background/80 hover:text-primary transition-colors">{t('footer.analyticsAI')}</a></li>
              <li><a href="#" className="text-background/80 hover:text-primary transition-colors">{t('footer.integrations')}</a></li>
            </ul>
          </div>

          {/* Empresa */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-background/80 hover:text-primary transition-colors">{t('footer.aboutUs')}</a></li>
              <li><a href="#" className="text-background/80 hover:text-primary transition-colors">Cases</a></li>
              <li><a href="/blog" className="text-background/80 hover:text-primary transition-colors">{t('header.blog')}</a></li>
              <li><a href="/comparar" className="text-background/80 hover:text-primary transition-colors">Compare</a></li>
              <li><a href="#" className="text-background/80 hover:text-primary transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Suporte */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">{t('footer.support')}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/privacidade" className="text-background/80 hover:text-primary transition-colors">{t('footer.privacy')}</a></li>
              <li><a href="/termos-de-uso" className="text-background/80 hover:text-primary transition-colors">{t('footer.terms')}</a></li>
              <li><a href="/etica" className="text-background/80 hover:text-primary transition-colors">{t('footer.ethics')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/20 pt-8 text-center">
          <p className="text-background/60 text-sm">
            © 2024 {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
